// extracted by css-extract-rspack-plugin
export default {"row":"os9XijkYalIgMbvu","labelRow":"pxc1HgSgkmMkcmYC","label":"xmCSF0i_A8kDu2CT","sliderValue":"JB1PQjhWgekzETAx","controls":"nArrJxj8ZTMDRdMp","slider":"tfPI3LxOoKPSV2ov"};